import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Image from 'quarks/Image';
import Paragraph from 'quarks/Paragraph';
import type { BasicProps } from 'quarks/interpolations/basic';

import Breadcrumbs from 'molecules/Breadcrumbs';
import Section from 'molecules/Section/Section';

import ComponentButton from 'components/Button/ComponentButton';
import List from 'components/List';
import LegalDisclaimer from 'components/ResourceComponents/LegalDisclaimer';

import type { ContentfulTemplateDownload } from 'graphqlTypes';
import type { FC } from 'react';

interface DownloadExitProps extends BasicProps, ContentfulTemplateDownload {}

const DownloadExitHero: FC<DownloadExitProps> = ({
  id,
  title,
  featuredImage,
  excerpt,
  takeawaysList,
  asset,
  ...props
}) => {
  const breadcrumbs = [{ label: 'Downloads', link: '/resources' }, { label: title || '' }];

  return (
    <Section
      id={id}
      paddingTopMobile={32}
      paddingTopTablet={72}
      paddingTopDesktop={96}
      paddingBottomMobile={56}
      paddingBottomDesktop={96}
      backgroundColor="gray-100"
    >
      <Container {...props}>
        <Breadcrumbs breadcrumbs={breadcrumbs} marginBottom={48} />
        <Flex
          width="100%"
          flexDirection="column"
          gap="32px"
          paddingBottom={48}
          md={{ paddingBottom: 56 }}
          lg={{ paddingBottom: 72, flexDirection: 'row' }}
        >
          <Flex flexDirection="column">
            {title && (
              <Heading textStyle="md" fontWeight="bold" marginBottom={16}>
                {title}
              </Heading>
            )}
            {excerpt && (
              <Paragraph fontSize="textXl" marginBottom={32}>
                {excerpt.excerpt}
              </Paragraph>
            )}
            {takeawaysList && (
              <Container marginBottom={32}>
                <List {...takeawaysList} tight />
              </Container>
            )}
            {asset?.file?.url && (
              <ComponentButton
                link={asset.file.url}
                label="Download"
                hierarchy="Primary Color"
                size="lg"
                endIcon="Download 01"
                width="100%"
                sm={{ width: 'fit-content' }}
              />
            )}
          </Flex>
          {featuredImage && (
            <Flex width="100%" alignItems="flex-start">
              <Image
                image={featuredImage}
                alt={featuredImage.title || 'Download Feature Image'}
                width="100%"
                borderRadius="8px"
                objectFit="contain"
                loading="eager"
              />
            </Flex>
          )}
        </Flex>
      </Container>
      <LegalDisclaimer />
    </Section>
  );
};

export default DownloadExitHero;
